import { accountantSearchColumns, accountSearchColumns, khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import { AccountModel, DoiTuong } from '@/types/schemas';
import { SearchField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface DetailTabProps {
  searchFieldStates: {
    customer: DoiTuong | null;
    setCustomer: (customer: DoiTuong | null) => void;
    profession: any | null;
    setProfession: (profession: any | null) => void;
    accountDebit: AccountModel | null;
    setAccountDebit: (accountDebit: AccountModel | null) => void;
    accountCredit: AccountModel | null;
    setAccountCredit: (accountCredit: AccountModel | null) => void;
  };
}

export const DetailTab: React.FC<DetailTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Mã khách hàng</Label>
          <SearchField<DoiTuong>
            type='text'
            name='customer_code'
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
            searchColumns={khachHangSearchColumns}
            dialogTitle='Danh mục đối tượng'
            columnDisplay='customer_code'
            displayRelatedField='customer_name'
            classNameRelatedField='w-full'
            value={searchFieldStates.customer?.customer_code}
            relatedFieldValue={searchFieldStates.customer?.customer_name}
            onRowSelection={searchFieldStates.setCustomer}
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Mã nghiệp vụ</Label>
          <SearchField<any>
            type='text'
            name='ma_ngvkt'
            searchEndpoint={`/${QUERY_KEYS.KHAI_BAO_NGHIEP_VU_KE_TOAN}/`}
            searchColumns={accountantSearchColumns}
            dialogTitle='Danh mục nghiệp vụ'
            columnDisplay='ma_ngvkt'
            displayRelatedField='ten_ngvkt'
            classNameRelatedField='w-full'
            value={searchFieldStates.profession?.ma_ngvkt}
            relatedFieldValue={searchFieldStates.profession?.ten_ngvkt}
            onRowSelection={searchFieldStates.setProfession}
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Tài khoản nợ</Label>
          <SearchField<AccountModel>
            type='text'
            name='code'
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
            searchColumns={accountSearchColumns}
            dialogTitle='Danh mục tài khoản'
            columnDisplay='code'
            displayRelatedField='name'
            classNameRelatedField='w-full'
            value={searchFieldStates.accountDebit?.code}
            relatedFieldValue={searchFieldStates.accountDebit?.name}
            onRowSelection={searchFieldStates.setAccountDebit}
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Tài khoản có</Label>
          <SearchField<AccountModel>
            type='text'
            name='code_co'
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
            searchColumns={accountSearchColumns}
            dialogTitle='Danh mục tài khoản'
            columnDisplay='code'
            displayRelatedField='name'
            classNameRelatedField='w-full'
            value={searchFieldStates.accountCredit?.code}
            relatedFieldValue={searchFieldStates.accountCredit?.name}
            onRowSelection={searchFieldStates.setAccountCredit}
          />
        </div>
      </div>
    </div>
  );
};
